    <crud-list class="col-12" [data]="table" [allowCreate]="app.mainConfig.adminUsersAllowAdd" detailUrl="/base2/admin/editGeneralUser/" restUrl="api/app/user">
    </crud-list>
